import { SetGhModelParametersError } from '@swd_admin/cdc-viewer';
import { useNotificationStore } from 'state/notificationstate/notificationstate';
import { StyleDefinitionError } from '@swd_admin/cdc-viewer';
import { NotEnoughSpaceOptionError } from '@swd_admin/cdc-viewer';
import { UnknownParentError } from '@swd_admin/cdc-viewer';
import { useUiState } from 'state/ui-state/ui-state';

export const handleGHModelParametersError = (
  error: SetGhModelParametersError
) => {
  const notification = useNotificationStore.getState();
  notification.setNotification(
    'notifications.viewer.error.ghModelParametersError',
    'error',
    'modal'
  );
};

export const handleStyleDefinitionError = (error: StyleDefinitionError) => {
  console.error(error.data?.map((d) => d.message));
};

export const notEnoughSpaceOptionError = (e: NotEnoughSpaceOptionError) => {
  const notification = useNotificationStore.getState();
  notification.setNotification(
    'notifications.viewer.error.cannotPlaceOptionError',
    'error',
    'small'
  );
};

export const cannotResizeBuildingError = (e: NotEnoughSpaceOptionError) => {
  const { setRemovableInstanceIds } = useUiState.getState();

  setRemovableInstanceIds(e.instanceIds);
};

// The viewer refused an option because its parent is not one the building
// has (usually: no wall selected yet); without this message "+" would appear
// to do nothing.
export const unknownParentError = (e: UnknownParentError) => {
  const notification = useNotificationStore.getState();
  notification.setNotification(
    'notifications.viewer.error.unknownParentError',
    'error',
    'small'
  );
};
